/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Today_Checkin_ErrorInputs */

const en_us2_today_checkin_error = /** @type {(inputs: Today_Checkin_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not send. Try again.`)
};

const pt_br2_today_checkin_error = /** @type {(inputs: Today_Checkin_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar. Tente de novo.`)
};

const es_419_today_checkin_error = /** @type {(inputs: Today_Checkin_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar. Intenta de nuevo.`)
};

const pt_pt2_today_checkin_error = /** @type {(inputs: Today_Checkin_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar. Tenta outra vez.`)
};

const fr_fr2_today_checkin_error = /** @type {(inputs: Today_Checkin_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoi impossible. Réessaie.`)
};

const de_de2_today_checkin_error = /** @type {(inputs: Today_Checkin_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senden fehlgeschlagen. Versuch es noch mal.`)
};

const it_it2_today_checkin_error = /** @type {(inputs: Today_Checkin_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile inviare. Riprova.`)
};

/**
* | output |
* | --- |
* | "Could not send. Try again." |
*
* @param {Today_Checkin_ErrorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const today_checkin_error = /** @type {((inputs?: Today_Checkin_ErrorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Today_Checkin_ErrorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_today_checkin_error(inputs)
	if (locale === "es-419") return es_419_today_checkin_error(inputs)
	if (locale === "pt-PT") return pt_pt2_today_checkin_error(inputs)
	if (locale === "fr-FR") return fr_fr2_today_checkin_error(inputs)
	if (locale === "de-DE") return de_de2_today_checkin_error(inputs)
	if (locale === "it-IT") return it_it2_today_checkin_error(inputs)
	return en_us2_today_checkin_error(inputs)
});
export { today_checkin_error as "today.checkin_error" }